<mat-card class="record-card">
  <div>
    <table class="table table-sm table-hover table-striped">
      <tr>
        <th class="record-title">Operation Type</th>
        <th class="record-title">Facet Name</th>
        <th class="record-title">User</th>
        <th class="record-title">Timestamp</th>
        <th class="record-title"><span style="padding-left: 8px;">Asset</span></th>
        <th class="record-title">Coordinates</th>
        <th class="record-title">Trace Data</th>
      </tr>
      <tbody>
      <tr *ngFor="let h of history">
        <td>{{ h.operationType }}</td>
        <td>{{ h.facetName }}</td>
        <td>{{ h.user }}</td>
        <td>{{ h.timestamp | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>
            <button mat-stroked-button *ngIf="h.traceData?.assetKey && h.traceData?.assetKey != traceFileKey" [disabled]="downloadUrl !== null" (click)="generateDownload(h.traceData?.assetKey)">{{formatAssetLink(h.traceData?.assetKey)}}</button>
            <a mat-stroked-button *ngIf="h.traceData?.assetKey == traceFileKey && downloadUrl !== null" (click)="downloadUrl = null; traceFileKey = null" [href]="downloadUrl" target="trace">download</a>
        </td>
        <td>
          <ae-json [json]="h.clientLocationCoordinates"></ae-json>
        </td>
        <td>
          <ae-json [json]="h.traceData"></ae-json>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</mat-card>

